(function () {
    var s = (typeof (Vendd) != "undefined" && Vendd.Scripts) || (typeof (Scripts) != "undefined" && Scripts);
    if (!s) return;
    s.load(function () {
        'use strict';
        var TrackingScriptName = 'SkroutzAnalytics';

        var TrackingModel = LhApp.Function.Tracking.getTrackingModel();
        var Tracker = LhApp.Function.Tracking.getTracker("skroutz", TrackingModel);

        if (!Tracker || !Tracker.Properties.SkroutzAnalyticsCode)
            return;

        var CanTrack = LhApp.Function.Tracking.canTrack();

        Init();

        function Init() {
            if (!CanTrack) return;

            (function (a, b, c, d, e, f, g) {a['SkroutzAnalyticsObject'] = e; a[e] = a[e] || function () {
                (a[e].q = a[e].q || []).push(arguments);}; f = b.createElement(c); f.async = true;
                f.src = d; g = b.getElementsByTagName(c)[0]; g.parentNode.insertBefore(f, g);
            })(window, document, 'script', 'https://analytics.skroutz.gr/analytics.min.js', 'skroutz_analytics');

            skroutz_analytics('session', 'connect', Tracker.Properties.SkroutzAnalyticsCode); 

            //TRACK order completion
            if (TrackingModel.IsThankYouPage && TrackingModel.CartProductsData && TrackingModel.Order) {
                if (TrackingModel.Order.IsAlreadyTracked)
                    return;

                var tracked = false;

                if (typeof angular !== 'undefined') {
                    angular.element(document).ready(function () {
                        var oScope = angular.element('.x-control.x-angular-control.x-checkoutorder').scope();

                        if (oScope && !tracked) {
                            if (TrackingModel.IsThankYouPage) //cookie consent had been granted
                            {
                                tracked = true;

                                var items = TrackingModel.CartProductsData;

                                var adjustedPriceItems = items.map(function (i) {
                                    return { Quantity: i.Quantity, PriceN: i.PriceN }
                                });

                                var orderDiscountsNotAppliedOnProductsN = TrackingData.Order.Discounts.Order.reduce(
                                    function (total, discount) {
                                        return total + (discount.IsSpitOnProducts ? 0 : discount.AmountN);
                                    }, 0);

                                if (orderDiscountsNotAppliedOnProductsN > 0)
                                    adjustedPriceItems = AdjustPrices(adjustedPriceItems, orderDiscountsNotAppliedOnProductsN);

                                var skroutzOrder = {
                                    order_id: TrackingModel.Order.Id,
                                    revenue: Math.max(0, TrackingModel.Order.TotalPriceN - TrackingModel.Order.PaymentCostN),
                                    shipping: TrackingModel.Order.ShippingCostN,
                                    tax: TrackingModel.Order.VatCostN
                                }
                                skroutz_analytics('ecommerce', 'addOrder', skroutzOrder);
                                if (console)
                                    console.log({ 'SkrouztAnalytics_addOrder': skroutzOrder });

                                for (var i = 0, len = items.length; i < len; i++) {
                                    var product = items[i];
                                    var productId = LhApp.Function.Tracking.getFeedItemId(product, null, Tracker);

                                    var skroutzOrderItem = {
                                        order_id: TrackingModel.Order.Id,
                                        product_id: productId,
                                        name: product.Name,
                                        price: adjustedPriceItems[i].PriceN,
                                        quantity: product.Quantity
                                    }
                                    skroutz_analytics('ecommerce', 'addItem', skroutzOrderItem);
                                    if (console)
                                        console.log({ 'SkrouztAnalytics_addItem': skroutzOrderItem });
                                };
                            }
                        }
                    });
                }
            }
        }

        function AdjustPrices(orderItems, priceReduction) {

            var orderItemsSumN = orderItems.reduce(
                function (total, item) {
                    return total + (item.PriceN * item.Quantity);
                },
                0);

            if (orderItemsSumN <= 0)
                return orderItems;

            var totalDistributedDiscount = 0;
            for (var k = orderItems.length - 1; k >= 0; k--) {
                var productVolumePercent = (orderItems[k].PriceN * orderItems[k].Quantity) / orderItemsSumN;

                var productDiscount;

                if (k == 0)
                    productDiscount = priceReduction - totalDistributedDiscount;
                else
                    productDiscount = productVolumePercent * priceReduction;

                totalDistributedDiscount = Math.round(totalDistributedDiscount + productDiscount, 2);

                var productUnitdiscount = Math.round(productDiscount / orderItems[k].Quantity, 2);
                orderItems[k].PriceN = Math.round(Math.max(0, orderItems[k].PriceN - productUnitdiscount), 2);
            }

            return orderItems;
        }
    });
})();
